<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">

            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mt-2">
                    <div class="col-6">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateServiceActivitymodal"
                            (click)="CreateupdateServiceActivity('new');clearServiceActivity()"
                            *ngIf="fp.serviceactivitymappingcreate">Add
                            Service Activity</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh</i>
                        </button>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <ejs-grid #gridServiceActivityGroup [dataSource]='GridList | async' [allowPaging]='true'
                            [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                            [allowResizing]='true' (dataStateChange)='dataChangeServiceActivity($event)'
                            [showColumnChooser]='true' (actionBegin)="onActionServiceActivity($event)"
                            [allowSorting]='true'>
                            <e-columns>
                                <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                                            *ngIf="fp.serviceactivitymappingupdate"
                                            data-bs-target="#CreateServiceActivitymodal"
                                            (click)="CreateupdateServiceActivity('edit');getDetails(data)"><i
                                                class="fa fa-edit"></i></button>&nbsp;
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="serviceGroupName" headerText="ServiceGroupName"
                                    type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="masterServiceName" headerText="ServiceCode" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>


                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='showServiceActivityColumns()'><i
                                                    class="fa fa-cog fa-lg" aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ejs-grid -->
<div class="row mb-2">
    <div class="col ">
        <div widget class="card border-0 box-shadow" style="min-height: 500px;">
            <div class="card-body  widget-body pt-2">

            </div>
        </div>
    </div>
</div>
<!-- For Create or Update Modal -->
<span id="openServiceActivityModal" data-bs-toggle="modal" data-bs-target="#CreateServiceActivitymodal"></span>
<div class="modal fade" id="CreateServiceActivitymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span *ngIf="ModalType =='new'"> Create Service Activity</span>
                    <span *ngIf="ModalType =='edit'">Update Service Activity</span>
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="clearServiceActivity()"></span>
                </button>
            </div>
            <div class="modal-body">


                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Service Group<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">

                        <ng-select [(ngModel)]="groupId" (ngModelChange)="GetServiceCodeDropdown(groupId)"
                            class="width25" [searchable]="true" [clearable]="true" bindLabel="Value" bindValue="Key"
                            [items]="ServiceGroupList">
                            <option *ngFor="let service of ServiceActivityArray" [value]="service.value">
                                {{service.label}}</option>
                        </ng-select>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-lg-5">
                        <label>Service Code<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select [(ngModel)]="ServiceActivityArray1.serviceId"
                            (ngModelChange)="getActivityTypeSatus(ServiceActivityArray1.serviceId)" [clearable]="true"
                            [searchable]="true" [items]="Service" bindLabel="Value" bindValue="Key"
                            [disabled]="groupId==null|| groupId == undefined || groupId==''">
                        </ng-select>
                    </div>
                </div>
                <!-- ---------------------------------------------------------------------------------------------------------------------------- -->
                <div class="row mt-3">
                    <div cdkDropListGroup class="row">
                        <div class="col-lg-6">
                            <div class="example-container">
                                <label>Available Activities</label>

                                <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="availableActivities"
                                    [cdkDropListConnectedTo]="todoList" class="example-list"
                                    (cdkDropListDropped)="drop($event)" id='root'>
                                    <div
                                        *ngIf="availableActivities.length == 0 && ModalType == 'new' && selectedActivities.length==0">
                                        <p>Select service to view activities</p>
                                    </div>
                                    <div *ngIf="availableActivities.length == 0 && ModalType == 'edit'">
                                        <p>No data available!</p>
                                    </div>
                                    <div class="example-box" *ngFor="let item of availableActivities" cdkDrag>
                                        {{item.Value}}</div>
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="example-container">
                                <label>Selected Activities</label>

                                <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="selectedActivities"
                                    [cdkDropListConnectedTo]="todoList" class="example-list"
                                    (cdkDropListDropped)="drop($event)">
                                    <div *ngIf="selectedActivities.length == 0">
                                        <p>No data available!</p>
                                    </div>
                                    <div class="example-box" *ngFor="let item of selectedActivities" cdkDrag>
                                        {{item.Value}}</div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>




                <!-- -------------------------------------------------------------------------------------------------------------------------------------- -->


            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateServiceActivity(ServiceActivityArray1);" [disabled]="isSaveorUpdateBoolean || (groupId==null||groupId==''||groupId==undefined||
            ServiceActivityArray1.serviceId==null||ServiceActivityArray1.serviceId==''
            ||ServiceActivityArray1.serviceId==undefined )">
                    <span *ngIf="ModalType =='new'"> Save & Close</span>
                    <span *ngIf="ModalType =='edit'">Update & Close</span>
                </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearServiceActivity()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeSAModal" data-bs-target="#deleteServiceActivityModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteServiceActivityModal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteServiceActivity()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearServiceActivity()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>